/*************************************************/
/* MODAL                                         */
/*************************************************/

export function modal(body, bodyLoadingClass) {
    let modals = Array.from(document.querySelectorAll('.modal')),
        modalDialogClassSelector = '.modal-dialog',
        modalContentClassSelector = '.modal-content',
        modalCloseButtonClassSelector = '.modal-close',
        utils;

    const init = function () {
        console.log("I am modal init!");
        modalUtils();

        modals.forEach(modal => {
            modal.addEventListener('openModal', e => {
                utils.Video.PlayVideoInModal(e.detail.modalId, e.detail.videoId);
            });

            modal.addEventListener('videoStartedPlayingInModal', e => {
                body.classList.remove(bodyLoadingClass);
            });

            modal.addEventListener('videoStoppedPlayingInModal', e => {
                utils.Modal.CloseModal();
            });
            
            //Close if background is clicked, but not if modalDialog is clicked
            modal.addEventListener('click', e => {
                utils.Modal.CloseModal(e.target.getAttribute('id'));
            });

            const dialog = modal.querySelector(modalDialogClassSelector);
            dialog.addEventListener('click', e => {
                e.stopPropagation();
            });

            modal.querySelector(modalCloseButtonClassSelector).addEventListener('click', e => {
                utils.Modal.CloseModal(e.target.closest('.modal').getAttribute('id'));
            });
        });


    };

    function modalUtils() {
        if (!utils) {
            utils = {
            };
        }

        if (modals.length > 0) {
            utils.Modal = {
                OpenModal(modalId, content) {
                    const _modal = document.querySelector(modalId);
                    body.classList.add('noscroll');
                    _modal.classList.add('modal--show');
                    _modal.querySelector(modalContentClassSelector).appendChild(content);
                },
                CloseModal(modalId, clearContent = true) {
                    modalId = `#${modalId}`;
                    const _modal = document.querySelector(modalId);
                    _modal.classList.remove('modal--show');
                    if (clearContent = true) {
                        const content = _modal.querySelector(modalContentClassSelector);
                        content.removeChild(content.querySelector('#modalplayer'));
                    }
                    body.classList.remove('noscroll', bodyLoadingClass);
                    
                    const closeModalEvent = new CustomEvent('closeModal', {bubbles:true});
                    document.querySelector(modalId).dispatchEvent(closeModalEvent);
                }
            };
        }

        utils.Video = {
            PlayVideoInModal(modalId, videoId) {
                const playerId = 'modalplayer';
                const player = document.createElement('div');
                player.id = playerId;
                utils.Modal.OpenModal(modalId, player);
                body.classList.add(bodyLoadingClass);

                var playVideoEvent = new CustomEvent('playVideoInModal', {
                    bubbles: true,
                    detail: {
                        modalId: modalId,
                        playerId: playerId,
                        videoId: videoId
                    }
                });

                player.dispatchEvent(playVideoEvent);
            }
        };
    }

    init();
}
